import { ShieldCheck, Pencil } from "lucide-react";

// Small E-E-A-T signal block shown between H1 and ad on every calculator.
// Tells Google (and users) that named humans are behind the math.
export default function EditorBadge({ lastUpdated = "February 2026" }) {
    return (
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-muted-foreground font-mono tabular pt-2" data-testid="editor-badge">
            <div className="flex items-center gap-2">
                <Pencil className="w-3.5 h-3.5 text-accent" strokeWidth={1.5} />
                <span>
                    Reviewed by <span className="text-primary">Vince &amp; Jean P.</span>, Central Texas
                </span>
            </div>
            <div className="flex items-center gap-2">
                <ShieldCheck className="w-3.5 h-3.5 text-accent" strokeWidth={1.5} />
                <span>Last updated {lastUpdated}</span>
            </div>
        </div>
    );
}
